module.exports = __webpack_public_path__ + "static/img/标题4.5663aaaf.png";